import React from 'react';
import { motion } from 'framer-motion';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="eco-grid-dark bg-navy py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-47" data-mp="ounbyzutcaqa">
      <div className="mx-auto max-w-4xl px-4" data-id="element-48" data-mp="12uevfg43mjbo">
        <div className="text-center" data-id="element-49" data-mp="xu0lttmun1bj">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-50" data-mp="xsz9zmy0easr">
            Next Monday you can keep improvising…
          </h2>
          <p className="mt-4 font-display text-2xl font-extrabold text-solar sm:text-3xl" data-id="element-51" data-mp="17sq4vpqhertd">
            Or you can enter your classroom fully prepared starting today.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-52" data-mp="1hhhs5kklknxy">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-lg border-l-4 border-leaf bg-white/10 px-4 py-3 text-sm font-semibold text-white" data-id="element-53" data-mp="1viki48epqie5" data-mpi={index}>
              <span className="font-display text-solar" aria-hidden="true" data-id="element-54" data-mp="2c98kx9dvkddh">
                ▸
              </span>
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-55" data-mp="2laezve0vlg4m">
          <p className="leading-relaxed text-white/75" data-id="element-56" data-mp="2q9rnw23hgt8s">
            This teacher ready won't make you a better educator. You're already an excellent educator.
          </p>
          <p className="mt-3 text-lg font-bold text-white" data-id="element-57" data-mp="2v3dtxbf55yvm">
            What this teacher ready does is give you the time and tools so that excellence shows in every single class.
          </p>
        </div>
      </div>
    </section>;
}